import React, { useMemo } from "react";
import { malletSVG } from "../lib/mallet";

export default function Hero() {
  const rackHTML = useMemo(() => {
    const specs = [
      { head: "rnpp", pattern: "tips", color2: "#F4F1EA", grip: "#F4F1EA", shaft: "flamed" },
      { head: "rnpp", pattern: "splash", headColor: "#F07A1E", color2: "#FF5CA8", grip: "#B8E62E" },
      { head: "skene", pattern: "band", color2: "#C81DD8", grip: "#C81DD8" },
      { head: "cigar", pattern: "natural", grip: "#1C1A18" },
      { head: "rnpp", pattern: "solid", color2: "#F4F1EA", shaft: "white", grip: "#F4F1EA", text: "AUBONE" },
    ];
    const inner = specs.map((s, i) => `<g transform="translate(${i * 100} 0) rotate(-78 340 90)">${malletSVG({ length: 52, ...s }).replace(/<svg[^>]*>/, "").replace("</svg>", "")}</g>`).join("");
    return `<svg viewBox="210 -200 620 660" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMax meet"><rect x="210" y="422" width="620" height="8" rx="4" fill="#8A5A22" opacity=".7"/>${inner}</svg>`;
  }, []);

  return (
    <section className="hero">
      <div className="wrap">
        <div className="hero-grid">
          <div>
            <h1>Cane mallets built<br />for the way you hit.</h1>
            <p className="lead">Handmade in Wellington, Florida. Every mallet is cut, weighted and balanced by hand — pick one off the rack, or design yours from the head up.</p>
            <div className="cta">
              <a className="btn btn-primary" href="#shop">Shop mallets</a>
              <a className="btn btn-ghost" href="#customize">Design your mallet</a>
              <a className="btn btn-ghost" href="#play">Play a chukka</a>
            </div>
          </div>
          <div className="hero-rack" aria-hidden="true" dangerouslySetInnerHTML={{ __html: rackHTML }} />
        </div>
        <div className="hero-note">
          <div><strong>Hand-balanced</strong>Each mallet weighed and swing-tested before it ships</div>
          <div><strong>Team sets</strong>Matching heads, engraved numbers and club colors</div>
          <div><strong>Repairs in days</strong>Regrips, new heads and shafts — drop off in Wellington</div>
        </div>
      </div>
    </section>
  );
}
